module.exports = __webpack_public_path__ + "static/img/banner-9.0db352a9.png";